export default __webpack_public_path__ + "static/mock-reward-3-a5fe913105c6312eb37a78d4843d86ff.webp";